// extracted by mini-css-extract-plugin
module.exports = {"render":"HMDashboard_render__SYNOb"};